/* eslint-disable no-underscore-dangle */

import { datadogRum } from '@datadog/browser-rum';
import env from 'utilities/env';
import { getAdminUserID } from 'utilities/auth/adminUserId';

/**
 * Initialize Datadog RUM (Real User Monitoring) with Session Replay
 */
export const initializeDatadogRum = (user) => {
  const applicationId = env('DATADOG_APPLICATION_ID');
  const clientToken = env('DATADOG_CLIENT_TOKEN');
  const envName = env('DATADOG_ENV');
  // Used to track the version of wonolo-web in Datadog.
  const version = env('DATADOG_VERSION') || '1.0.0';

  // Validate required configuration
  if (!applicationId || !clientToken) {
    console.warn('Datadog RUM: Missing required configuration (DATADOG_APPLICATION_ID or DATADOG_CLIENT_TOKEN)'); // eslint-disable-line no-console
    return;
  }

  try {
    // Check if already initialized using window flag
    if (!window._datadogRumInitialized) {
      datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: 'wonolo-web',
        env: envName,
        // Specify a version number to identify the deployed version of your application in Datadog
        version,

        // Session sampling configuration
        sessionSampleRate: 100, // Sample 100%

        // Session Replay configuration
        sessionReplaySampleRate: 100, // Record 100%
        trackBfcacheViews: true, // Track back/forward cache views

        // Privacy configuration
        defaultPrivacyLevel: 'allow', // Allow all data (including user input)

        // Interaction tracking
        trackInteractions: true,

        // Performance monitoring
        trackResources: true,
        trackLongTasks: true,

        // Error tracking
        trackUserInteractions: true,

        allowedTracingUrls: [
          /^https?:\/\/(?:[a-z0-9-]+\.)+(?:wonolo\.com|wonolo-dev\.com|wonolo-shared\.com|wonolo-prod\.com)(?=\/|$)/i,
        ],
      });

      window._datadogRumInitialized = true;
    }

    // Set user context if provided
    if (user) {
      const userContext = {
        name: user.fullName,
        email: user.email,
        customer_id: user.customer?.id,
        user_id: user.id,
        role: user.role,
        admin_id: getAdminUserID() // Gets admin_user_id from storage when login_as is used
      };

      // Remove undefined/null values
      const cleanUserContext = Object.fromEntries(
        Object.entries(userContext).filter(([_, value]) => value !== undefined && value !== null)
      );

      datadogRum.setUser({
        id: user.id,
        ...cleanUserContext
      });
    }
  } catch (error) {
    console.error('Datadog RUM: Failed to initialize', error); // eslint-disable-line no-console
  }
};

export default { initializeDatadogRum };
